import * as InfinityTableActionModel from "Redux/Actions/Models/InfinityTableActionModel";
import * as ActionTypes from "Redux/Actions/EnumTypes/ActionEnumTypes";


function setInfinityTableCount(value: number): InfinityTableActionModel.SetCountAction {
    return {
        type: ActionTypes.InfinityTable.SET_COUNT,
        payload: {
            count: value
        }
    };
}

function setInfinityTableTotalCount(value: number): InfinityTableActionModel.SetTotalCountAction {
    return {
        type: ActionTypes.InfinityTable.SET_TOTAL_COUNT,
        payload: {
            totalCount: value
        }
    };
}

function setInfinityTableAllCounts(count: number, totalCount: number): InfinityTableActionModel.SetAllCountsAction {
    return {
        type: ActionTypes.InfinityTable.SET_ALL_COUNTS,
        payload: {
            count,
            totalCount
        }
    };
}

function setInfinityTableLoading(value: boolean): InfinityTableActionModel.SetLoadingAction {
    return {
        type: ActionTypes.InfinityTable.SET_LOADING,
        payload: {
            isLoading: value
        }
    };
}

export {
    setInfinityTableCount,
    setInfinityTableLoading,
    setInfinityTableTotalCount,
    setInfinityTableAllCounts
};



// WEBPACK FOOTER //
// ./src/Redux/Actions/InfinityTableActions.ts